module.exports = __webpack_public_path__ + "assets/img/Image.784baba6.png";